<template>
	<v-dialog :value="value" max-width="520px" persistent @input="$emit('input', $event)">
		<v-card class="background-2 round-card" data-test="export-dialog">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Esporta CSV</p>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pt-4">
				<div class="mb-3">
					<span class="font-weight-medium primary--text">{{ count }}</span>
					{{ count === 1 ? 'elemento da esportare' : 'elementi da esportare' }}
				</div>
				<v-radio-group v-model="mode" :disabled="running" hide-details class="mt-0">
					<v-radio value="simple" label="Semplice — le colonne visibili della tabella"></v-radio>
					<v-radio v-if="details.length" value="advanced" label="Avanzato — una riga per ogni riga del documento"></v-radio>
				</v-radio-group>
				<v-select v-if="mode === 'advanced' && details.length > 1"
					v-model="detailKey"
					:items="details"
					item-value="key"
					item-text="label"
					label="Dettaglio"
					:disabled="running"
					class="mt-4"
					outlined
					dense
					hide-details
				></v-select>
				<div v-if="tooManyItems" class="caption error--text mt-4" data-test="export-too-many">
					Con la selezione manuale si esportano al massimo {{ maxItems.toLocaleString('it-IT') }} righe.
					Per esportarne di più seleziona l'intera lista (anche col «Seleziona tutti» sopra la tabella) oppure restringi i filtri.
				</div>
				<div v-if="!explicitItems" class="caption mt-4" data-test="export-background-note">
					Il file si prepara sul server: puoi continuare a lavorare, lo scarichi dal riquadro in basso
					o dagli Archivi quando è pronto.
				</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="info" text @click="$emit('input', false)">Annulla</v-btn>
				<v-btn color="primary" text :loading="running" :disabled="running || !count || tooManyItems" @click="start">Esporta</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { exportFileName, MAX_EXPLICIT_ITEMS } from '@/services/crudExport'
	import { trackCsvExport } from '@/services/csvExports'

	export default {
		name: 'crud-export-dialog',
		props: {
			value: Boolean,
			button: Object,
			modelDef: String,
			count: Number,
			columns: Array,
			// righe selezionate a mano, null in modalità "tutti"
			explicitItems: Array,
			// () → {uri, payload}: la richiesta lista della tabella, congelata al clic su Esporta
			listRequest: Function,
		},
		data() {
			return {
				mode: 'simple',
				detailKey: null,
				running: false,
				maxItems: MAX_EXPLICIT_ITEMS,
			}
		},
		computed: {
			details() {
				return (this.button && this.button.details) || []
			},
			tooManyItems() {
				return !!this.explicitItems && this.explicitItems.length > MAX_EXPLICIT_ITEMS
			},
		},
		watch: {
			value(open) {
				if (open) {
					this.mode = 'simple'
					this.detailKey = this.details.length ? this.details[0].key : null
				}
			},
		},
		methods: {
			async start() {
				const advanced = this.mode === 'advanced'
				const spec = {
					model: this.modelDef,
					columns: this.columns,
					translations: this.$trans.dictionary(),
					detail: advanced ? this.detailKey : null,
				}
				this.running = true
				try {
					if (this.explicitItems) {
						// selezione manuale: poche righe, il file torna nella risposta (errore: snackbar di openFile)
						const downloaded = await this.$eventBusUtility.openFile(this.$store, '/csv-exports', exportFileName(this.modelDef, advanced), 'POST', { ...spec, items: this.explicitItems })
						if (!downloaded) {
							return
						}
					} else {
						const response = await this.axios.post('csv-exports', { ...spec, list: this.listRequest() })
						trackCsvExport({ id: response.data.id, total: response.data.total, title: this.$trans(this.modelDef) + (advanced ? ' (righe)' : '') })
					}
					this.$emit('input', false)
				} catch (error) {
					this.$store.commit('setSnackbar', { timeout: 6000, text: 'Esportazione non riuscita', value: true, color: 'error' })
				} finally {
					this.running = false
				}
			},
		},
	}
</script>
